const getAlert = (state) => state.alert;

export const getAlertType = (state) => getAlert(state).type;

export const getAlertMessage = (state) => getAlert(state).message;

export const getAlertShow = (state) => getAlert(state).show;
